export default function FormSkeleton() {
  return (
    <div className="animate-pulse space-y-6 max-w-[32rem] mt-6 ml-4">
      <div>
        <div className="h-5 w-3/4 bg-gray-200 rounded mb-2" />
        <div className="h-10 w-full bg-gray-100 rounded" />
      </div>
      <div>
        <div className="h-5 w-3/4 bg-gray-200 rounded mb-2" />
        <div className="h-10 w-full bg-gray-100 rounded" />
      </div>
      <div className="h-10 w-32 bg-gray-300 rounded" />
    </div>
  );
}
